// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/app/components/shared/ExternalLink.module.css';
import FocusRing from '@app/features/ui/focus_ring/FocusRing';
import {openExternalUrl} from '@app/features/ui/utils/NativeUtils';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';
import type {AnchorHTMLAttributes, FC, MouseEventHandler} from 'react';
import {useRef} from 'react';

type ExternalLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
	href: string;
	children: React.ReactNode;
};
export const ExternalLink: FC<ExternalLinkProps> = observer(({href, children, className, ...props}) => {
	const linkRef = useRef<HTMLAnchorElement>(null);
	const handleClick: MouseEventHandler<HTMLAnchorElement> = async (event) => {
		event.preventDefault();
		event.stopPropagation();
		await openExternalUrl(href);
	};
	return (
		<FocusRing ringTarget={linkRef}>
			<a
				ref={linkRef}
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				className={clsx(styles.externalLink, className)}
				onClick={handleClick}
				{...props}
			>
				{children}
			</a>
		</FocusRing>
	);
});
